import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { OrderService } from "src/app/frontoffice/order/order.service";
import { OrderItem, OrderDescription } from "src/app/frontoffice/order/model/orderItemcategory.model";
import { InvoiceItemAdditive, InvoiceItemDescription, InvoiceItem } from "src/app/frontoffice/order/model/invoice.model";
import { LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";
import { Validators, UntypedFormControl, UntypedFormGroup, FormControl, FormGroup } from "@angular/forms";
import { OrderSettingModel } from "../../../model/ordersetting.model";
import { RowState } from "../../../../../../../projects/sepidz-web-framework/src/lib/models/enums";
import { ItemOrderService } from "../itemorder.service";
import { take } from "rxjs/operators";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";

@Component({
  selector: "order-description",
  templateUrl: "./description.component.html",
  styleUrls: ["./description.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ItemOrderService],
})
export class DescriptionComponent extends BaseListComponent {
  currentItem: OrderItem;
  _rotate: boolean = true;
  showBox: boolean;
  dailyInventory: boolean = false;

  formGroup: FormGroup = new FormGroup({
    justInBasket: new FormControl(null),
  });

  constructor(
    public order: OrderService,
    private itemservice: ItemOrderService,
    public cd: ChangeDetectorRef,
    public storage: LocalStoreManager,
    private common: CommonService
  ) {
    super();
    this.NoLog = true;
    order.cd_Description = cd;
  }
  ngOnInit() {
    let group: any = {};
    group["ExtraDescription"] = new UntypedFormControl(undefined, Validators.maxLength(200));
    group["Extraingredient"] = new UntypedFormControl(undefined, Validators.maxLength(200));
    this.group = new UntypedFormGroup(group);
    if (!this.order.isLight) this.initializeInvColumns();
    this.dailyInventory = this.common.LocalSetting.OrderSetting.OrderDescriptionBox;
  }

  public stateChange(): void {
    if (this.order.OrderSetting.IsShowDescriptionBox) {
      this._rotate = false;
    }
    if (!this.order.OrderSetting.IsShowDescriptionBox) {
      this._rotate = true;
    }
    if (this.order.OrderSetting) this.order.OrderSetting.IsShowDescriptionBox = !this.order.OrderSetting.IsShowDescriptionBox;
    else {
      this.order.OrderSetting = new OrderSettingModel();
      this.order.OrderSetting.IsShowDescriptionBox = !this.order.OrderSetting.IsShowDescriptionBox;
    }
    this.common.updateSettings(this.order.OrderSetting);
  }
  addAdditive(item: any) {
    if (this.order.invoice.Items.length <= 0) return;
    item.IsSelected = !item.IsSelected;
    const find_item = this.order.selectedInvoiceItem;
    if (item.IsSelected) {
      const find_item = this.order.selectedInvoiceItem;
      let additive = new InvoiceItemAdditive();
      additive.AdditiveId = item.Id;
      additive.qty = 1;
      additive.UnitPrice = item.MainPrice;
      additive.AdditiveTitle = item.Title;
      additive.ApplyTax = item.ApplyTax;
      additive.ApplyService = item.ApplyService;
      additive.Tax = item.Tax;
      additive.State = RowState.New;
      additive.Toll = item.Toll;
      additive.PackingPrice = item.PackingPrice;
      const find_PriceType = item.Prices?.find((f) => f.SalePriceTypeId === this.order.invoice.SalePriceTypeId);
      if (find_PriceType) additive.MainPrice = find_PriceType?.Price;
      else additive.MainPrice = item.Prices?.find((f) => f.IsDefault).Price;
      const findInvoiceItem = this.order.invoice.Items.find((f) => f.ItemId === find_item.ItemId && f.Index === find_item.Index);
      if (findInvoiceItem) {
        if (
          !this.order.HasAccess("PositiveEditOrderingStatus") &&
          !this.order.HasAccess("PositiveEditClearingStatus") &&
          !this.order.HasAccess("PositiveEditClearedStatus") &&
          !this.order.HasAccess("PositiveEditAssignedStatus")
        ) {
          this.sts.showToast(
            "danger",
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Description.ErrorMessage"),
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Description.AccessToThisArea")
          );
          item.IsSelected = false;
          return;
        }
        findInvoiceItem.Additives.push(additive);
      }
    } else {
      const find = this.order.invoice.Items.findIndex((f) => f.ItemId === find_item.ItemId && f.Index === find_item.Index);
      const find_description_Index = this.order.invoice.Items[find].Additives.findIndex((f) => f.AdditiveId === item.Id);
      this.order.invoice.Items[find].Additives.splice(find_description_Index, 1);
    }
    if (!item.IsSelected) {
      const mainstring = this.order.invoice.Items.find((f) => f.ItemId === find_item.ItemId && f.Index === find_item.Index).Description;
      this.order.invoice.Items.find((f) => f.ItemId === find_item.ItemId && f.Index === find_item.Index).Description = mainstring.replace(
        item.Title + " ، ",
        ""
      );
    } else {
      this.order.invoice.Items.find((f) => f.ItemId === find_item.ItemId && f.Index === find_item.Index).Description += item.Title + " ، ";
    }
    this.refreshItemDescription(find_item);
  }
  addDescription(item: OrderDescription) {
    if (this.order.invoice.Items.length <= 0) return;
    item.IsSelected = !item.IsSelected;
    const find_item = JSON.parse(JSON.stringify(this.order.selectedInvoiceItem));
    if (item.IsSelected) {
      const orderDescription = new InvoiceItemDescription();
      orderDescription.DescriptionId = item.Id;
      orderDescription.DescriptionTitle = item.Title;
      orderDescription.State = RowState.New;
      const findInvoiceItem = this.order.invoice.Items.find((f) => f.ItemId === find_item.ItemId && f.Index === find_item.Index);
      if (findInvoiceItem) {
        orderDescription.InvoiceItemId = findInvoiceItem.Id;
        findInvoiceItem.Descriptions.push(orderDescription);
      }
    } else {
      const find = this.order.invoice.Items.findIndex((f) => f.ItemId === find_item.ItemId && f.Index === find_item.Index);
      const find_description_Index = this.order.invoice.Items[find].Descriptions.findIndex((f) => f.DescriptionId === item.Id);
      if (find_description_Index >= 0) this.order.invoice.Items[find].Descriptions.splice(find_description_Index, 1);
    }
    if (!item.IsSelected) {
      const mainstring = this.order.invoice.Items.find((f) => f.ItemId === find_item.ItemId && f.Index === find_item.Index).Description;
      this.order.invoice.Items.find((f) => f.ItemId === find_item.ItemId && f.Index === find_item.Index).Description = mainstring.replace(
        item.Title + " ، ",
        ""
      );
    } else {
      this.order.invoice.Items.find((f) => f.ItemId === find_item.ItemId && f.Index === find_item.Index).Description += item.Title + " ، ";
    }
    this.refreshItemDescription(find_item);
  }
  refreshItemDescription(invoiceitem: InvoiceItem) {
    this.order.itemChanged = true;
    this.order.calculate();
    this.itemservice.scrollToItem(invoiceitem, true);
  }
  addCustomDescription() {
    if (
      !this.order.formGroup.controls[`CustomDescription${this.order.invoice.SaleMethodBranchId}`].value ||
      this.order.formGroup.controls[`CustomDescription${this.order.invoice.SaleMethodBranchId}`].value === "" ||
      !this.order.selectedInvoiceItem
    )
      return;
    if (!this.order.CustomDescriptionId) {
      this.httpCommonService
        .get(`Description/CustomDescription`)
        .pipe(take(1))
        .subscribe((data: number) => {
          this.order.CustomDescriptionId = data;
          const des = new OrderDescription();
          des.Title = this.order.formGroup.controls[`CustomDescription${this.order.invoice.SaleMethodBranchId}`].value;
          des.Id = data;
          this.addDescription(des);
          this.order.formGroup.controls[`CustomDescription${this.order.invoice.SaleMethodBranchId}`].setValue("");
          this.showBox = !this.showBox;
          this.order.detectChanges();
        });
    } else {
      const desc = new OrderDescription();
      desc.Title = this.order.formGroup.controls[`CustomDescription${this.order.invoice.SaleMethodBranchId}`].value;
      desc.Id = this.order.CustomDescriptionId;
      this.addDescription(desc);
      this.order.formGroup.controls[`CustomDescription${this.order.invoice.SaleMethodBranchId}`].setValue("");
      this.showBox = !this.showBox;
      this.order.detectChanges();
    }
  }
  // حذف توضیح
  removeItemDescription(additive: OrderDescription, invoiceitem: InvoiceItem) {
    if (
      invoiceitem?.Descriptions?.length > 0 &&
      invoiceitem?.Descriptions.some((s) =>
        s.DescriptionTitle.includes(this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Description.ManualDescription"))
      )
    ) {
      if (additive.IsSelected) {
        const mainstring = this.order.invoice.Items.find((f) => f.ItemId === invoiceitem.ItemId && f.Index === invoiceitem.Index).Description;
        this.order.invoice.Items.find((f) => f.ItemId === invoiceitem.ItemId && f.Index === invoiceitem.Index).Description = mainstring.replace(
          additive.Title,
          ""
        );
      } else {
        this.order.invoice.Items.find((f) => f.ItemId === invoiceitem.ItemId && f.Index === invoiceitem.Index).Description += additive.Title + " ، ";
      }
    } else {
      this.refreshItemDescription(invoiceitem);
    }
  }
  ClearCustomDescription() {
    this.order.setValue(`CustomDescription${this.order.invoice.SaleMethodBranchId}`, "");
  }
  ShowDescription() {
    this.showBox = !this.showBox;
    setTimeout(() => {
      this.order.focus(`CustomDescription${this.order.invoice.SaleMethodBranchId}`);
    }, 50);
  }

  onShowMinimumJustInBasketChanges(showMinimumJustInBasket: boolean) {
    const branchId = this.order.invoice.BranchId || this.order.logInBranch.Id;
    if (showMinimumJustInBasket) {
      let list = [];
      this.order.invoice?.Items?.forEach((item) => {
        const stockItems = this.order.dailyInventoryList.filter((x) => x.ItemsInRelation.some((x) => x.Id === item.ItemId));
        list.push(...stockItems);
      });
      this.order.dailyInventoryList = list;
    } else this.order.setDailyInventoryList(branchId);
    this.cd.markForCheck();
  }

  private initializeInvColumns() {
    this.columns = [
      {
        name: "GoodsCode",
        modelName: "GoodsCode",
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Description.ItemCode"),
        order: 0,
        textType: "number",
        formVisible: false,
        disabled: false,
        areaName: "default",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 100,
      },
      {
        name: "GoodsTitle",
        modelName: "GoodsTitle",
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Description.ItemTitle"),
        order: 0,
        textType: "number",
        formVisible: false,
        disabled: false,
        areaName: "default",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 150,
      },
      {
        name: "MinAmount",
        modelName: "MinAmount",
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Description.MinimumInventory"),
        order: 0,
        textType: "number",
        formVisible: false,
        disabled: false,
        areaName: undefined,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 120,
      },
      {
        name: "EntryAmount",
        modelName: "EntryAmount",
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Description.Charge"),
        order: 0,
        textType: "number",
        formVisible: false,
        disabled: false,
        areaName: undefined,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 70,
      },
      {
        name: "SaleAmount",
        modelName: "SaleAmount",
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Description.Sell"),
        order: 0,
        textType: "number",
        formVisible: false,
        disabled: false,
        areaName: undefined,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 70,
      },
      {
        name: "Amount",
        modelName: "Amount",
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Description.Inventory"),
        order: 0,
        textType: "number",
        formVisible: false,
        disabled: false,
        areaName: undefined,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 70,
      },
    ];
  }

  dailyInventoryShow(state: "desc" | "dailyInventory") {
    if (state === "desc") {
      this.dailyInventory = false;
      this.common.LocalSetting.OrderSetting.OrderDescriptionBox = false;
      this.common.updateSettings();
    } else {
      this.dailyInventory = true;
      this.common.LocalSetting.OrderSetting.OrderDescriptionBox = true;
      this.common.updateSettings();
    }
  }
}
